import { z } from "zod";
import { CommunityAsset } from "./asset.js";
/**
 * Profile image upload contract. The member picks an image on the settings
 * page, crops it to a square in the browser, and posts the cropped base64
 * bytes here. The backend re-validates, re-encodes to JPEG via
 * {@link CommunityImagePipeline}, and stores the derivative as a published
 * `community_assets` row. The `community_profiles.avatar_url` is set to
 * `/api/community/assets/:assetId` so the existing asset delivery route
 * serves it, and `profile_image_asset_id` points at the new row.
 *
 * `width` and `height` are the client-claimed source dimensions; the pipeline
 * re-measures the processed derivative and the stored values come from there.
 *
 * Brand rule: no em-dashes (U+2014) or en-dashes (U+2013) anywhere.
 */
export const UploadProfileImageRequest = z.object({
    dataBase64: z.string().min(1),
    mime: z.enum(["image/jpeg", "image/png", "image/webp"]),
    width: z.number().int().positive().optional(),
    height: z.number().int().positive().optional(),
});
export const UploadProfileImageResponse = z.object({
    asset: CommunityAsset,
});
export const RemoveProfileImageResponse = z.object({
    removed: z.boolean(),
});
//# sourceMappingURL=profile-image.js.map